import React, { useState, useEffect } from 'react';
import axios from '../helpers/axiosConfig';
import { toast } from 'react-toastify';
import { json, useNavigate, useParams } from 'react-router-dom';

const EditDirecteur = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [directeurData, setDirecteurData] = useState({
    observation: '',
    du: '',
    au: '',
    personnelId: null,
    ledirecteur: '',
  });

  useEffect(() => {
    const fetchDirecteur = async () => {
      try {
        const response = await axios.get(`directeurs/edit/${id}`);
        const directeurData = response.data;
        setDirecteurData({
          ...directeurData,
          observation: directeurData.observation || '',
          du: directeurData.du || '',
          au: directeurData.au || '',
          personnelId: directeurData.personnelId || null,
          ledirecteur: directeurData.personnel ? directeurData.personnel.nomprenom : '',
        });

        if (directeurData.personnelId) {
          const personnelResponse = await axios.get(`personnel/show/${directeurData.personnelId}`);
          setDirecteurData({
            ...directeurData,
            ledirecteur: personnelResponse.data.nomprenom || null,
          });
        }
      } catch (err) {
        toast.error('Erreur lors de la récupération des informations', err);
      }
    };

    fetchDirecteur();
  }, [id]);

  const [searchTerm, setSearchTerm] = useState('');
  const [personnelSuggestions, setPersonnelSuggestions] = useState([]);

  // Fonction pour gérer les changements dans le formulaire
  const handleChange = (e) => {
    const { name, value } = e.target;
    setDirecteurData({ ...directeurData, [name]: value });
  };

  // Fonction pour gérer la recherche des personnels
  const handleSearchChange = (e) => {
    const value = e.target.value;
    setDirecteurData({
      ...directeurData,
      ledirecteur: value,
    });

    // Rechercher les personnels si la recherche n'est pas vide
    if (value) {
      axios
        .get(`personnel/x/2?nomprenom=${value}`)
        .then((response) => {
          setPersonnelSuggestions(response.data.slice(0, 10)); // Limiter à 10 suggestions
        })
        .catch((error) => {
          toast.success(error.response.data.error);
        });
    } else {
      setPersonnelSuggestions([]);
    }
  };

  // Fonction pour gérer la soumission du formulaire
  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append('directeurData', JSON.stringify(directeurData));

    try {
      const response = await axios.put(`directeurs/${id}`, formData, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      toast.success('Directeur créé avec succès !');
      navigate('/directeurs');
    } catch (error) {
      toast.error(error.response.data.error); // Utiliser toast.error ici
    }
  };

  // Fonction pour sélectionner un personnel
  const handleSelectPersonnel = (personnel) => {
    setDirecteurData({
      ...directeurData,
      personnelId: personnel.id,
      ledirecteur: personnel.nomprenom,
    });

    setPersonnelSuggestions([]); // Effacer les suggestions
  };

  return (
    <div className="container mt-5">
      <h1>Ajouter un Directeur</h1>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label className="form-label">Observation</label>
          <input type="text" name="observation" className="form-control" value={directeurData.observation} onChange={handleChange} />
        </div>
        <div className="mb-3">
          <label className="form-label">Du</label>
          <input type="text" name="du" className="form-control" value={directeurData.du} onChange={handleChange} />
        </div>
        <div className="mb-3">
          <label className="form-label">Au</label>
          <input type="text" name="au" className="form-control" value={directeurData.au} onChange={handleChange} />
        </div>
        <div className="mb-3">
          <label className="form-label">Recherche Personnel</label>
          <input type="text" className="form-control" value={directeurData.ledirecteur} onChange={handleSearchChange} placeholder="Tapez pour chercher..." />
          {personnelSuggestions.length > 0 && (
            <ul className="list-group mt-2">
              {personnelSuggestions.map((personnel) => (
                <li key={personnel.id} className="list-group-item list-group-item-action" onClick={() => handleSelectPersonnel(personnel)}>
                  {personnel.nomprenom}
                </li>
              ))}
            </ul>
          )}
        </div>
        <button type="submit" className="btn btn-primary">
          Enregistrer la Modification
        </button>
      </form>
    </div>
  );
};

export default EditDirecteur;
